export const amountListFormatter = (value: string | undefined | null) => {
  if (value === undefined || value === null) {
    return '';
  }
  const pointGroups = `${value}`.match(/^([0-9]*).?([0-9]*)/);
  const beforePoint = pointGroups?.[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const afterPoint = pointGroups?.[2] ?? `00`;
  return `${beforePoint}.${afterPoint[0] ?? 0}${afterPoint[1] ?? 0}`;
};

export const onSearch = (data: unknown) => {
  const { searchValue } = data as { searchValue: string };
  return [
    {
      field: '',
      operator: 'contains' as const,
      value: searchValue,
    },
  ];
};

export const getNetWorkByName = (dataNetwork: any[], networkId: number | string) => {
  const network = dataNetwork.find((item: any) => item.id === Number(networkId));
  return network?.nativeCurrencySymbol || '';
};

export const getSymbolByName = (dataCurrencyToken: any[], currencyId: number | string) => {
  const currency = dataCurrencyToken.find((item: any) => item.id === Number(currencyId));
  return currency?.symbol || currency?.name || '';
};

export const getDecimalsBySymbol = (symbol?: string | null) => {
  if (!symbol) {
    return 0;
  }
  switch (symbol) {
    case 'ETH':
      return 6;
    case 'DAI':
      return 4;
    case 'USDT':
      return 4;
    case 'USD':
      return 2;
    case 'EUR':
      return 2;
    case 'HKD':
      return 2;
    case 'AUD':
      return 2;
    case 'JPY':
      return 2;
    case 'CHF':
      return 2;
    case 'CNY':
      return 2;
    case 'AED':
      return 2;
    case 'SGD':
      return 2;
    case 'GBP':
      return 2;
    default:
      return 0;
  }
};